module.exports = __webpack_public_path__ + "media/images/icon_about-ffafc67a2e97ca436da6c1bf61a8ab68.png";